import React from "react";

const statColors: Record<string, {bg: string; color?: string}> = {
  "High":       {bg: "var(--color-high)",    color: "white"},
  "Average":    {bg: "var(--color-avg)",     color: "white"},
  "Essential":  {bg: "var(--color-high)",    color: "white"},
  "Advantage":  {bg: "var(--color-avg)",     color: "white"},
  "Defect":     {bg: "var(--color-high)",    color: "white"},
  "High (var)": {bg: "#fb7718",              color: "white"},
  "Modest":     {bg: "var(--color-pos-qgi)"},
};

const labelMap: Record<string, string> = {
  "High (var)":       "High",
  "Defect/Advantage": "Mixed",
  "Advantage":        "Gain",
};

export const classifyExpression = (exp: number): string => {
  if (exp > 5) return "High";
  if (exp < 1) return "Low";
  return "Average";
};

const StatTile = ({title, subtitle, label, value, className = "col-6 col-md-3"}: {
  title: string;
  subtitle?: string;
  label?: string;
  value?: string | number | null;
  className?: string;
}) => {
  const colors = label ? statColors[label] : undefined;
  const style: React.CSSProperties = colors
    ? {backgroundColor: colors.bg, ...(colors.color && {color: colors.color})}
    : {backgroundColor: "var(--color-low)"};

  return (
    <div className={className}>
      <div className="rounded p-3 text-center h-100 d-flex flex-column stat-tile" style={style}>
        <div className="fw-bold fs-5">{title}</div>
        {subtitle && <div className="small opacity-75">{subtitle}</div>}
        <div className="mt-auto pt-2 small fw-bold">{labelMap[label ?? ""] || label || "—"}</div>
        {value != null && <div className="small">{value}</div>}
      </div>
    </div>
  );
};

export default StatTile;